export default __webpack_public_path__ + "static/media/copy_link_menu_icon.ab03c964.svg";